<template>
  <a-card title="基本信息">
    <a-tabs style="background-color: white;" default-active-key="1">
      <a-tab-pane tab="基本信息" key="1">
        <BasicInfoComponents></BasicInfoComponents>
      </a-tab-pane>
      <a-tab-pane tab="主体信息" key="2">
        <SubjectInfoComponents></SubjectInfoComponents>
      </a-tab-pane>
      <a-tab-pane tab="经营许可证" key="3">
        <ManageInfoComponents></ManageInfoComponents>
      </a-tab-pane>
    </a-tabs>
  </a-card>
</template>
<script>
import BasicInfoComponents from './components/BasicInfoComponents'
import SubjectInfoComponents from './components/SubjectInfoComponents'
import ManageInfoComponents from './components/ManageInfoComponents'

export default {
  name: 'BasicSettings',
  components: { BasicInfoComponents, SubjectInfoComponents, ManageInfoComponents },
  data() {
    return {}
  },
  mounted() {
  },
  methods: {}

}
</script>
<style scoped>
</style>